import React from "react";
import { Link } from "react-router-dom";
import { ClipLoader } from 'react-spinners';

const CheckoutOrderSummary = (props) => {
    const { subtotal,
        discountAmount,
        totalAmount,
        discountApplied,
        projectPaymentGateway,
        handlePaymentMethodChange,
        productFormData,
        loading,
        onCreateOrder,
        removeCoupon,
        setCouponCode,
        couponCode,
        applyCoupon,
        setDiscountApplied,
        customReqId,
    } = props;

    return (
        <div className="cart-paydetail w-100 box-border px-3">
            <div className="order-total d-flex justify-content-start align-items-center">
                <span className="main-total fw-bold">Order Summary</span>
            </div>
            {discountApplied ? (
                <div className="applied_discount_message col-12">
                    <span className="coupon_code_applied">Coupon Code Applied: ₹ {discountAmount.toFixed(2)}</span>
                    <button className="remove_button" onClick={removeCoupon}>
                        {/* Remove */}
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            id="Bold"
                            viewBox="0 0 24 24"
                            width="25"
                            height="25"
                            version="1.1"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            xmlnsSvgjs="http://svgjs.dev/svgjs"
                        >
                            <g transform="matrix(1,0,0,1,0,0)">
                                <path
                                    d="M14.121,12L18,8.117A1.5,1.5,0,0,0,15.883,6L12,9.879,8.11,5.988A1.5,1.5,0,1,0,5.988,8.11L9.879,12,6,15.882A1.5,1.5,0,1,0,8.118,18L12,14.121,15.878,18A1.5,1.5,0,0,0,18,15.878Z"
                                    fill="#fc722d"
                                    fillOpacity="1"
                                    stroke="none"
                                    strokeOpacity="1"
                                />
                            </g>
                        </svg>
                    </button>
                </div>
            ) : (
                <>
                    <div className="coupon_input mb-2 mt-3 d-flex">
                        <input
                            type="text"
                            className="col-9"
                            value={couponCode}
                            onChange={(e) => setCouponCode(e.target.value)}
                            placeholder="Enter Coupon Code"
                        />
                        <button className="col-3 web_button_coupon" onClick={applyCoupon}>Apply</button>
                    </div>
                </>
            )}
            <div className="payment-detail mb-3">
                <div className="card-border-bottom d-flex justify-content-between align-items-center">
                    <span className="subtotal">Subtotal</span>
                    <span className="amount">₹ {subtotal}</span>
                </div>
                <div className="card-border-bottom d-flex justify-content-between align-items-center">
                    <span className="shipping">Shipping (Standard)</span>
                    <span className="amount">Free</span>
                </div>
                {discountApplied && (
                    <div className="card-border-bottom d-flex justify-content-between align-items-center">
                        <span className="left_heading">Discount</span>
                        <span className="right_text">₹ {discountAmount}</span>
                    </div>
                )}
                <div className="card-border-bottom d-flex justify-content-between align-items-center">
                    <span className="subtotal">Total</span>
                    <span className="amount">₹ {totalAmount.toFixed(2)}</span>
                </div>
            </div>
            {customReqId ? (
                projectPaymentGateway
                    .filter(gateway => gateway.paymentGatewayId === 1)
                    .map(gateway => (
                        <div className="select_payment_mode mt-1 d-flex align-items-center" key={gateway.paymentGatewayId}>
                            <input
                                className="select_address_button"
                                type="radio"
                                name="paymentmode"
                                value={gateway.paymentGatewayId}
                                onChange={handlePaymentMethodChange}
                                checked={productFormData.paymentGatewayTypeId === gateway.paymentGatewayId}
                            />
                            <label className="payment_method_gateway">{gateway.displayName}</label>
                        </div>
                    ))
            ) : (
                projectPaymentGateway.map(gateway => (
                    <div className="select_payment_mode mt-1 d-flex align-items-center" key={gateway.paymentGatewayId}>
                        <input
                            className="select_address_button"
                            type="radio"
                            name="paymentmode"
                            value={gateway.paymentGatewayId}
                            onChange={handlePaymentMethodChange}
                            checked={productFormData.paymentGatewayTypeId === gateway.paymentGatewayId}
                        />
                        <label className="payment_method_gateway">{gateway.displayName}</label>
                    </div>
                ))
            )}


            {subtotal !== 0 && subtotal !== null ?
                <div className="checkout mt-md-2 pt-2">
                    <button
                        className="web_button"
                        onClick={onCreateOrder}
                        disabled={loading}
                    >
                        {loading ? (
                            <ClipLoader color="#fff" size={20} />
                        ) : (
                            'Place Order'
                        )}
                    </button>
                </div> :
                <button className="cart_btn_add" >
                    <Link to='/' title="About Gailee – Learn about our brand">Continue Shopping</Link>
                </button>
            }
        </div>
    )
}

export default CheckoutOrderSummary;